import type {
  QueryParams,
  FilterQuery,
  SortOption,
} from './DefaultQueryFormatter'
import DefaultQueryFormatter from './DefaultQueryFormatter'
import { storyblokDateFormat } from '~/utils/storyblok'

/**
 * SearchQueryFormatter
 *
 * @extends DefaultQueryFormatter
 */
export default class SearchQueryFormatter extends DefaultQueryFormatter {
  override getSortOptions(_params: QueryParams = {}): SortOption[] {
    return [
      { label: 'Relevancy', value: 'relevancy' },
      { label: 'Most Recent', value: 'published_at:desc' },
    ]
  }

  /**
   * Any Events returned in Search should be current/future only
   * Checks for `date_end` later than [now] OR `date_start` empty
   * (Start is always filled for events, but does not exist for other content)
   *
   * Note: uses currently undocumented "__or" filter
   * https://github.com/storyblok/storyblok/issues/94#issuecomment-618463685
   */
  override getFilterQuery(params: QueryParams = {}): FilterQuery {
    const date = new Date()
    date.setHours(0, 0, 0, 0)

    return {
      filter_query: {
        ...(super.getFilterQuery(params)?.filter_query || {}),
        __or: [
          {
            date_end: {
              gt_date: storyblokDateFormat(date),
            },
          },
          {
            date_start: {
              is: 'empty',
            },
          },
        ],
      },
    }
  }

  override getDefaultFilters(): QueryParams {
    return {
      states: [],
      topics: [],
      audiences: [],
      'resource-type': [],
    }
  }
}
